function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { DomNode, Emitter } from '@bydesign-ui/hooks';
import { NestWatcher } from '../../../models/nest-watcher';
import { getRelativeKeys } from '../util';
import { FormNodeType } from '../types';

var DEFAULT_ERROR_PROCESSOR = function DEFAULT_ERROR_PROCESSOR(errors) {
  return errors[0];
};

export var FormGroup = function (_Emitter) {
  _inherits(FormGroup, _Emitter);

  var _super = _createSuper(FormGroup);

  function FormGroup(form, scope, options) {
    var _this;

    _classCallCheck(this, FormGroup);

    _this = _super.call(this);
    _this.id = guid();
    _this.captureChildError = false;
    _this.errorProcessor = DEFAULT_ERROR_PROCESSOR;
    _this.errors = [];
    _this.valid = false;
    _this.msg = '';
    var _options$field = options.field,
        field = _options$field === void 0 ? '' : _options$field,
        _options$repeat = options.repeat,
        repeat = _options$repeat === void 0 ? false : _options$repeat,
        _options$defaultValue = options.defaultValue,
        defaultValue = _options$defaultValue === void 0 ? {} : _options$defaultValue;
    _this.form = form;
    _this.node = new DomNode({
      type: FormNodeType.GROUP,
      repeat: repeat,
      field: field,
      id: _this.id
    }, scope);
    _this.field = field;

    _this.init(defaultValue);

    return _this;
  }

  _createClass(FormGroup, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$field2 = options.field,
          field = _options$field2 === void 0 ? '' : _options$field2,
          _options$errorProcess = options.errorProcessor,
          errorProcessor = _options$errorProcess === void 0 ? DEFAULT_ERROR_PROCESSOR : _options$errorProcess,
          _options$captureChild = options.captureChildError,
          captureChildError = _options$captureChild === void 0 ? false : _options$captureChild;

      if (field !== this.field) {
        throw new Error('field should not be updated');
      }

      this.errorProcessor = errorProcessor;
      this.captureChildError = captureChildError;

      if (!captureChildError) {
        this.valid = true;
        this.msg = '';
      }
    }
  }, {
    key: "isField",
    value: function isField() {
      return false;
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return true;
    }
  }, {
    key: "isRepeat",
    value: function isRepeat() {
      return false;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.msg = '';
    }
  }, {
    key: "getGroupInfo",
    value: function getGroupInfo() {
      if (!this.captureChildError) {
        return {
          msg: '',
          valid: true,
          scope: this.node
        };
      }

      return {
        msg: this.msg,
        valid: this.valid,
        scope: this.node
      };
    }
  }, {
    key: "getNode",
    value: function getNode() {
      return this.node;
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return NestWatcher.combineKeys(getRelativeKeys(this.node));
    }
  }, {
    key: "processValidateResult",
    value: function processValidateResult(id, error) {
      if (!this.captureChildError) {
        return;
      }

      var index = this.errors.findIndex(function (item) {
        return item.id === id;
      });
      var updated = false;

      if (error == null || error.valid) {
        if (index >= 0) {
          this.errors.splice(index, 1);
          updated = true;
        }
      } else if (index < 0) {
        this.errors.push({
          id: id,
          msg: error.msg
        });
        updated = true;
      } else if (this.errors[index].msg !== error.msg) {
        this.errors[index].msg = error.msg;
        updated = true;
      }

      if (updated) {
        var msg = this.errorProcessor(this.errors.map(function (item) {
          return item.msg;
        }));
        var valid = this.errors.length <= 0;

        if (msg !== this.msg || this.valid !== valid) {
          this.msg = msg;
          this.valid = valid;
          this.emit('repaint');
        }
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this2 = this;

      this.form.unregister(this);
      this.form.unwatch(this.id);
      this.node.getChildNodes().forEach(function (node) {
        return _this2.form.disposeNode(node);
      });
      this.node.remove();
    }
  }, {
    key: "init",
    value: function init(defaultValue) {
      this.form.register(this);

      if (this.field) {
        var value = this.form.getPathValue(NestWatcher.combineKeys(getRelativeKeys(this.node)));

        if (value == null) {
          this.form.setPathValue(NestWatcher.combineKeys(getRelativeKeys(this.node)), defaultValue, true);
        }
      }
    }
  }]);

  return FormGroup;
}(Emitter);